import { ContentTypeEnum } from "~/types/enum/ContentTypeEnum";
import { ContentTextType } from "~/types/article/content/ContentTextType";
import { ContentRandomRecipesByCategoryType } from "~/types/article/content/ContentRandomRecipesByCategoryType";
import { RuntimeConfig } from "nuxt/schema";
import { ContentImageTextType } from "~/types/article/content/ContentImageTextType";

export const contentAutoMapper = (ctx: object, config: RuntimeConfig) => {
    switch (ctx?.__component) {
        case ContentTypeEnum.Text:
            return contentTextMapper(ctx);
        case ContentTypeEnum.RandomRecipesByCategory:
            return contentRandomRecipesByCategoryMapper(ctx);
        case ContentTypeEnum.ImageText:
            return contentImageTextMapper(ctx, config);
    }

    return null;
}

export const contentTextMapper = (ctx: object) => {
    return <ContentTextType>{
        type: ctx?.__component,
        text: ctx.text,
        changePosition: _isBoolean(ctx?.change_position) ? ctx?.change_position : false,
    };
}

export const contentRandomRecipesByCategoryMapper = (ctx: object) => {
    return <ContentRandomRecipesByCategoryType>{
        type: ctx?.__component,
        title: ctx.title,
        recipeCategory: {
            title: ctx?.recipe_category?.data?.attributes?.title,
            slug: ctx?.recipe_category?.data?.attributes?.slug,
            url: `/interesting-facts/category-${ctx?.recipe_category?.data?.attributes?.slug}`,
        }
    };
}

export const contentImageTextMapper = (ctx: object, config: RuntimeConfig) => {
    return <ContentImageTextType>{
        type: ctx?.__component,
        text: ctx?.text,
        changePosition: _isBoolean(ctx?.change_position) ? ctx?.change_position : false,
    };
}